import { FC } from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/utils/store";
import Toasts from "./Toasts";

const ToastDialogs: FC = () => {
  const { toasts } = useSelector((state: RootState) => state.toasts);

  return (
    <>
      {!!toasts.length && (
        <div>
          {toasts.map((toast) => (
            <Toasts key={toast.id} toast={toast} />
          ))}
        </div>
      )}
    </>
  );
};

export default ToastDialogs;
